import { useCallback, useEffect, useState } from "react";
import AdminManagementLayout from "../components/admin/AdminManagementLayout";
import RenderingManager from "../components/admin/RenderingManager";
import { API } from "../data/siteData";
import useAdminAccess from "../hooks/useAdminAccess";

export default function AdminRenderingsPage() {
  const accessState = useAdminAccess();
  const [renderings, setRenderings] = useState([]);
  const [state, setState] = useState("loading");

  const loadRenderings = useCallback(async () => {
    try {
      const response = await fetch(`${API}/admin/renderings`, { credentials: "include" });
      if (!response.ok) throw new Error();
      setRenderings(await response.json());
      setState("ready");
    } catch {
      setState("error");
    }
  }, []);

  useEffect(() => {
    if (accessState === "ready") loadRenderings();
  }, [accessState, loadRenderings]);

  if (accessState === "loading" || state === "loading") return <main className="portal-state" data-testid="admin-renderings-loading">Loading rendering controls…</main>;
  if (state === "error") return <main className="portal-state" data-testid="admin-renderings-error">Rendering controls are temporarily unavailable.</main>;

  return <AdminManagementLayout active="renderings" eyebrow="Control Room materials" title="RENDERING GALLERY"><RenderingManager renderings={renderings} onRefresh={loadRenderings} /></AdminManagementLayout>;
}